import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'
import styles from './QISoftware.module.scss';

const WinQIDesc = () => {
    return (<>

        <Container className='outerContainer'>
            <h1 className="mb-4 centerText">WinQI Software</h1>
            <p className="lead centerText">Flexibility and ease-of-use for users preferring a traditional GUI</p>
        </Container>
        <div className={styles.downloadBox}>
            <Container className="outerContainer">

                <h3 className="pb-3 centerText">WinQI v2021 Software</h3>
                <Row>
                    <Col md={7} ><div>
                        <img className="mr-2 fullwidth round" src="/images/winqi-sample.png" />
                        <p className="mt-4 mb-1">Software improvements include:</p>
                        <ul>
                            <li>Enhancements to select indicators</li>
                            <li>Implementations around the isolation of COVID-19 discharges</li>
                            <li>Running WinQI as Service to improve automation within WinQI</li>
                            <li>Performance Improvements in the risk adjustments process</li>
                            <li>Access to technical specifications from within WinQI</li>
                        </ul>
                        <p className="mb-1 danger">Note:</p>
                        <ul>
                            <li>To learn what changed in v2021 <a href="https://qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2021/AHRQ_WinQI_v2021_Software_Rel_Notes.pdf">click here.</a></li>
                            <li>To see frequently asked questions, <a href="https://www.qualityindicators.ahrq.gov/News/ICD10_v2021_FAQ.pdf">click here</a> to access v2021 software release FAQ document.</li>
                        </ul>
                    </div>
                    </Col>
                    <Col md={1} className={styles.verticalLine}/>
                    <Col md={{ span: 4 }}>
                        <div className="mb-3">
                            <Row>
                                <h4>WinQI v2021 64-Bit with APR-DRG Grouper Version v2021, July 2021 </h4>

                                <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2021/quality_indicators_2021_x64_Setup_With_APR-DRG.zip">Download</Button>
                                <p className="mt-2 mb-0 subtitle">Version v2021, July 2021</p>

                            </Row>
                        </div>
                        <hr className="mt-1" />

                        <div className="mb-3">
                            <Row>
                                <h4>WinQI v2021 64-Bit without APR-DRG Grouper Version v2021, July 2021</h4>

                                <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2021/quality_indicators_2021_x64_Setup_Without_APR-DRG.zip">Download</Button>
                                <p className="mt-2 mb-0 subtitle">Version v2021, July 2021</p>
                            </Row>
                        </div>
                        <hr className="mt-1" />

                        <div className="mb-3">
                            <Row>
                                <h4>WinQI v2019.x.x Software Update Patch, October 2020</h4>
                                <p className="subtitle danger">For those using WinQI v2019 and don't have their own MDC data.</p>

                                <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2019/WinQIv2019DataPatch.zip">Download</Button>
                                <p className="mt-2 subtitle">Patch version v2019-01, October 2020<br />
                                    This software patch adds back a few missing MS-DRG values that may impact the generation of MDC values in WinQI v2019.x.x if not provided by the user in their input data. Users providing the MDC value in their input data may not need to run this patch. Click here to learn about the patch</p>
                            </Row>
                        </div>
                    </Col>


                </Row>
            </Container>
        </div>
    </>)
}

export default WinQIDesc;